import React from 'react';
import Loadable from 'react-loadable';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import s from './Home.css';
import * as actions from '../../actions/home';
import Layout from '../../components/global/Layout';
import LoadMore from '../../components/common/LoadMore';
import Nav from '../../components/p_home/Nav'
import SlideArea from '../../components/p_home/SlideArea'
import Section from '../../components/p_home/Section'
import Pop from '../../components/p_home/Pop'
import PrivacyPolicy from '../../components/p_home/PrivacyPolicy'
import AgreementDialog from '../../components/p_home/AgreementDialog';
import storage from '../../core/storage'

const Loading = () => <div>Loading...</div>;

const LoadableStaticShow = Loadable({
  loader: () => import('../../components/p_home/StaticShow'),
  loading: Loading,
});

class Home extends React.Component {

  constructor(props) {
    super(props)
    this.loadHomeMore = this.loadHomeMore.bind(this)
  }

  componentDidMount() {
    const { home, showPop } = this.props
    if (home.popup) {
      const storageData = storage.load()
      if (!storageData || (storageData && !storageData[home.popup.url])) {
        showPop()
      }
    }
    const { hostname, pathname } = window.location

    if (hostname === 'xue.youdao.com' && pathname === '/') {
      window.location.href = window.location.href.replace('xue.youdao.com', 'ke.youdao.com')
    }
  }

  loadHomeMore() {
    const { homeMoreFetch, home } = this.props
    if (home.tagRecommends.length === 0) return null
    return homeMoreFetch(home.tagRecommends)
  }

  render() {
    const { home, closePop, signingAgreement } = this.props;
    if (!home || !home.fixedEntries) return null
    return (
      <Layout>
        <div className={s.homeWholeContent}>
          {/* SEO 优化，不展示在页面中 */}
          <h1 className={s.title}>有道精品课-为你精选好课</h1>
          <Nav tags={home.fixedEntries} />
          <SlideArea
            head={home.head}
            popularCourses={home.popularCourse}
            discover={home.discover}
            serialCourse={home.serial}
          />
          <div className={s.content}>
            {
              home.tagRecommendCourses && home.tagRecommendCourses.map((tag, inx) => (
                <Section key={`sec-${inx}-${tag.tag.id}`} data={tag} />
              ))
            }
            <LoadMore
              onReachBottom={this.loadHomeMore}
              hasMore={home.tagRecommends.length !== 0}
            />
            {
              home.pop && home.popup ?
                <Pop data={home.popup} closePop={closePop} /> : null
            }
          </div>
          <LoadableStaticShow />
          <PrivacyPolicy />
          <AgreementDialog
            protocolUrl={home.protocolUrl}
            signingAgreement={signingAgreement}
            showAgreement={home.needWindow}
          />
        </div>
      </Layout>
    );
  }
}

Home.propTypes = {
  home: PropTypes.shape({
    fixedEntries: PropTypes.array.isRequired,
    layout: PropTypes.array.isRequired,
    tagRecommends: PropTypes.array.isRequired,
    inited: PropTypes.bool.isRequired,
    pop: PropTypes.bool.isRequired,
    discover: PropTypes.array.isRequired,
    serial: PropTypes.array,
    head: PropTypes.array,
    popularCourse: PropTypes.array,
    tagRecommendCourses: PropTypes.array,
    needWindow: PropTypes.bool,
    protocolUrl: PropTypes.string,
    popup: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
  homeMoreFetch: PropTypes.func.isRequired,
  showPop: PropTypes.func.isRequired,
  closePop: PropTypes.func.isRequired,
  signingAgreement: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Home))



// WEBPACK FOOTER //
// ./src/routes/home/Home.js